import { ORGANIZATION_KINDS } from 'store/organizations';

export const LABELS = {
  [ORGANIZATION_KINDS.NURSING_HOME]: 'Zentrum löschen',
  [ORGANIZATION_KINDS.OPTICIAN]: 'Optiker löschen',
  [ORGANIZATION_KINDS.CLINIC]: 'Arzt löschen',
};
